const ERROR_TRANSLATION_KEYS = {
  validEmail: 'email-valid'
};

export const getErrorTranslationKey = (error, errorTranslationKey) => {
  return errorTranslationKey || ERROR_TRANSLATION_KEYS[error] || error;
};

export const getFormErrorMessage = ({
  t,
  getTranslation,
  errorBaseKey,
  error,
  errorTranslationKey
}) => {
  const translationKey = getErrorTranslationKey(error, errorTranslationKey);
  const errorPath = `${errorBaseKey}.${translationKey}`;
  const directTranslation = t(errorPath);

  if (directTranslation !== errorPath) return directTranslation;

  const translatedError = getTranslation(t, errorPath);

  if (translatedError && !translatedError.endsWith(errorPath)) return translatedError;

  const fallbackPath = `error.${translationKey}`;
  const fallbackError = getTranslation(t, fallbackPath);

  return fallbackError?.endsWith(fallbackPath) ? '' : fallbackError;
};
